export default () => {
  // elements
  const els = {
    bar: document.querySelector('[data-announcement]'),
    header: document.querySelector('[data-new-layout-header]'),
    close: document.querySelector('[data-announcement-close]'),
    body: document.body,
  };

  const classes = {
    bodyAnnouncementShow: 'body--announcement-show',
  };

  const promoHidden = window.sessionStorage.getItem(
    'hide-announcement-bar'
  );

  if (els.bar && els.header) {
    const announcementBarHeight = els.bar.offsetHeight;
    const navbarHeight = els.header.offsetHeight;

    // Bar always shows (state selector lives here).
    // Close button only dismisses the promo message text.
    const marqueeEl = els.bar.querySelector('.announcement__marquee');
    const closeEl = els.bar.querySelector('.announcement__close');

    const showBar = () => {
      els.bar.style.maxHeight = `${els.bar.scrollHeight}px`;
      els.body.classList.add(classes.bodyAnnouncementShow);
      const headerSection = document.querySelector('header.section-header');
      if (headerSection) {
        headerSection.style.height = announcementBarHeight + navbarHeight + 'px';
      }
      enableMarqueeIfNeeded();
    };

    const hidePromo = () => {
      if (marqueeEl) marqueeEl.style.display = 'none';
      if (closeEl) closeEl.style.display = 'none';
      // Below the desktop-header breakpoint the state-selector is hidden
      // too (see _announcement.scss), so once the promo is dismissed the
      // bar would render as an empty blue strip. The CSS hook on this
      // class collapses the bar entirely on those viewports while leaving
      // it visible on desktop where the state-selector still lives there.
      els.bar.classList.add('announcement--promo-hidden');
      if (window.matchMedia('(max-width: 1199px)').matches) {
        els.body.classList.remove(classes.bodyAnnouncementShow);
        // Clear the inline height set by `showBar()` (which baked in the
        // announcement-bar's 45px) so the header section re-flows to its
        // natural height now the bar is gone.
        const headerSection = document.querySelector('header.section-header');
        if (headerSection) headerSection.style.height = '';
      }
      window.sessionStorage.setItem('hide-announcement-bar', true);
    };

    // Marquee logic
    function enableMarqueeIfNeeded() {
      if (!marqueeEl) return;
      const text = marqueeEl.querySelector('.announcement__text');
      if (!text) return;

      if (text.scrollWidth > marqueeEl.offsetWidth) {
        marqueeEl.classList.add('marquee-active');
        const textWidth = text.scrollWidth;
        const gapWidth = 100;
        const baseSpeed = 70;
        const pauseTime = 0.5;
        const totalDistance = textWidth + gapWidth;
        const animationDuration = Math.max(8, totalDistance / baseSpeed) + (pauseTime * 2);
        text.setAttribute('data-text', text.textContent);
        marqueeEl.style.setProperty('--marquee-duration', `${animationDuration}s`);
      } else {
        marqueeEl.classList.remove('marquee-active');
        marqueeEl.style.removeProperty('--marquee-duration');
      }
    }

    // event listeners
    if (els.close) {
      els.close.addEventListener('click', (e) => {
        e.preventDefault();
        hidePromo();
      });
    }

    // init — bar always shows; promo text may be dismissed
    showBar();
    if (promoHidden === 'true') {
      hidePromo();
    }

    window.addEventListener('resize', enableMarqueeIfNeeded);
    window.addEventListener('DOMContentLoaded', enableMarqueeIfNeeded);
  }
};
